import * as React from 'react';
import * as styles from './SinglePhoneComponent.css';
import { UIHeading4 } from '@cian/ui-kit';

export const SinglePhoneComponent = ({ phone }: { phone: string }) => {
  return (
    <div data-testid="SinglePhoneComponent" className={styles['phone']}>
      <UIHeading4 fontWeight="bold">{phone}</UIHeading4>
    </div>
  );
};
